<script setup lang="ts">
import { watch } from 'vue';

import { useTabsStore } from '@/stores/useTabsStore';
import { notificationsTabs } from '@/constants/tabs';

export interface Props {
  chooseTab: (category: string) => Promise<void>;
}
const props = withDefaults(defineProps<Props>(), {});

const tabsStore = useTabsStore();

watch(() => tabsStore.tabs.notifications, props.chooseTab);
</script>

<template>
  <v-window
    v-model="tabsStore.tabs.notifications"
    :class="$style.noticesVWindow"
    data-testid="noticesVWindow"
    :touch="false"
  >
    <v-window-item
      v-for="(tabValue, tabKey, tabIndex) in notificationsTabs"
      :key="tabKey"
      :value="tabKey"
    >
      <slot></slot>
    </v-window-item>
  </v-window>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.noticesVWindow {
}
</style>
